"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var stimulus_1 = require("stimulus");
var axios_1 = __importDefault(require("axios"));
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var dialog_store_1 = __importDefault(require("~/stores/dialog_store"));
var SnsShareModal_1 = __importDefault(require("~/components/modal/SnsShareModal"));
var HelpfulCountController = /** @class */ (function (_super) {
    __extends(HelpfulCountController, _super);
    function HelpfulCountController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.incrementStatus = 'pending';
        _this.increment = function () {
            if (_this.incrementStatus !== 'pending') {
                return;
            }
            _this.incrementStatus = 'doing';
            var apiBlogHelpfulsPath = _this.data.get('api-blog-helpfuls-path');
            if (!apiBlogHelpfulsPath) {
                return;
            }
            axios_1.default
                .post(apiBlogHelpfulsPath)
                .then(_this.handleSuccessHelpful)
                .catch(function () {
                _this.incrementStatus = 'pending';
                dialog_store_1.default.showErrorDialog('役に立ったのフィードバックに失敗しました');
            });
        };
        _this.handleSuccessHelpful = function () {
            _this.incrementStatus = 'completed';
            var count = Number(_this.data.get('count'));
            if (_this.countTextTargets) {
                _this.countTextTargets.forEach(function (countTextTarget) {
                    countTextTarget.textContent = (count + 1).toString();
                });
            }
            if (_this.buttonTextTargets) {
                _this.buttonTextTargets.forEach(function (buttonTextTarget) {
                    buttonTextTarget.textContent = 'フィードバック済み';
                });
            }
            var modalElement = document.createElement('div');
            _this.element.appendChild(modalElement);
            react_dom_1.default.render(react_1.default.createElement(SnsShareModal_1.default, { subject: "\u30B3\u30E9\u30E0" }), modalElement);
        };
        return _this;
    }
    HelpfulCountController.targets = ['countText', 'buttonText'];
    return HelpfulCountController;
}(stimulus_1.Controller));
exports.default = HelpfulCountController;
